import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import { AgentsSupervisorComponent } from "../agents-supervisor/agents-supervisor.component";
import {CampaignSupervisorComponent} from "../campaign-supervisor/campaign-supervisor.component";
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-supervisor-layout',
  imports: [
    CommonModule,
    TranslateModule,
    AgentsSupervisorComponent,
    CampaignSupervisorComponent,
  ],
  templateUrl: './supervisor-layout.component.html',
  styleUrl: './supervisor-layout.component.scss',
  standalone: true,
})
export class SupervisorLayoutComponent implements OnInit {
  options: string[] = [
    "Campañas",
    "Agentes",
  ]

  selectedOption: string = "Campañas"

  constructor(
      private route: ActivatedRoute,
    ) {
    this.route.queryParamMap.subscribe(queryParams => {
      this.selectedOption = queryParams.get('option') ?? "Campañas";
    });
  }

  ngOnInit() {
    console.log('🚀 Inicializando SupervisorLayoutComponent');
  }

  selectOption(option: string) {
    this.selectedOption = option
  }
}
